import { connect } from "react-redux";
import ViewDetails from "./viewDetails";
import { bindActionCreators } from "redux";
import { getDetails, infraProjectMap, projectMappingDetails } from "services/redux/sales/preSaleListing/action"
import { acceptLeadApproval, rejectLeadApproval,getExistingProject } from "services/redux/approvals/salesApprovals/action"

const mapStateToProps = (state) => ({
  viewDetails: state.preSalesListReducer.viewDetails,
  mappedInfraProject: state.preSalesListReducer.mappedInfraProject,
  existingProjectList: state.salesApprovalReducer.existingProjectList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDetails,
      acceptLeadApproval,
      getExistingProject,
      rejectLeadApproval,
      infraProjectMap,
      projectMappingDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewDetails);
